import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {ReactNode, useEffect} from 'react';

interface RenderIfBrakePadDataKrProps {
  vin: string;
  onNoData?: () => void;
  children: ReactNode;
}

function RenderIfBrakePadDataKr({vin, onNoData = () => {}, children}: RenderIfBrakePadDataKrProps) {
  const {data: brakePadData} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.brakePad.getBrake1), vin],
    queryFn: () => diApi.brakePad.getBrake1({vin}),
  });
  useEffect(() => {
    if (!brakePadData?.data) {
      onNoData();
    }
  }, []);

  if (!brakePadData?.data) {
    return null;
  }
  return <>{children}</>;
}

export default RenderIfBrakePadDataKr;
